// =====================================================================
// ConfirmDeleteDialog — confirmacao simples antes de DELETE (Fase 3, S38).
// =====================================================================
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress
} from "@material-ui/core";

const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  itemLabel,
  saving
}) => (
  <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Confirmar exclusão</DialogTitle>
    <DialogContent>
      <Typography variant="body2">
        Deletar <strong>{itemLabel || "este item"}</strong>?
      </Typography>
      <Typography
        variant="caption"
        color="textSecondary"
        style={{ display: "block", marginTop: 8 }}
      >
        Esta ação não pode ser desfeita.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={saving}>
        Cancelar
      </Button>
      <Button
        onClick={onConfirm}
        disabled={saving}
        style={{ color: "#e53935" }}
        startIcon={saving ? <CircularProgress size={18} /> : null}
      >
        {saving ? "Excluindo…" : "Excluir"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteDialog;
